SNI.Application.addModule('we-recommend', function(context) {

  return {
    behaviors: ['lazy-load']
  };

});
